import { render, staticRenderFns } from "./OnboardingChooseCreationTypeModal.vue?vue&type=template&id=f5b859e6&scoped=true"
import script from "./OnboardingChooseCreationTypeModal.vue?vue&type=script&lang=js"
export * from "./OnboardingChooseCreationTypeModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingChooseCreationTypeModal.vue?vue&type=style&index=0&id=f5b859e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b859e6",
  null
  
)

export default component.exports